import { Shield, Zap, Heart, Activity, Flame, Star, Skull, Crosshair, Siren, Stethoscope, Ambulance, Syringe } from "lucide-react";

export const EMBLEMS = { shield: Shield, zap: Zap, heart: Heart, activity: Activity, flame: Flame, star: Star, skull: Skull, crosshair: Crosshair, siren: Siren, stethoscope: Stethoscope, ambulance: Ambulance, syringe: Syringe };

export const COLORS = ["#4ade80", "#f59e0b", "#ef4444", "#38bdf8", "#a78bfa", "#f472b6", "#facc15", "#e5e7eb"];

export const API_BASE = process.env.REACT_APP_BACKEND_URL;

export function ClanLogo({ logo, size = 56, className = "" }) {
  const px = { width: size, height: size };
  if (logo?.type === "image" && logo.path) {
    return (
      <img
        src={`${API_BASE}/api/files/${logo.path}`}
        alt="Clan logo"
        style={px}
        className={`object-cover border border-border ${className}`}
        data-testid="clan-logo-image"
      />
    );
  }
  const Icon = EMBLEMS[logo?.emblem] || Shield;
  const color = logo?.color || COLORS[0];
  return (
    <div
      style={{ ...px, borderColor: color, color, background: `${color}14` }}
      className={`flex items-center justify-center border ${className}`}
      data-testid="clan-logo-emblem"
    >
      <Icon style={{ width: size * 0.55, height: size * 0.55 }} />
    </div>
  );
}
